//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.favourite_video;
//  -- Examples array selector --------


export const useFavouriteVideo = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}